<img [src]="data.thumbnail" [alt]="data.fileName" />
